import { api, type FetchOptions } from "@/api"
import {
  queryOptions,
  useMutation,
  useQuery,
  type UseMutationOptions,
} from "@tanstack/react-query"

const auditLogsKeys = {
  all: ["auditlog"] as const,
  list: () => [...auditLogsKeys.all, "list"] as const,
  lists: <TQuery>(query: TQuery) => [...auditLogsKeys.list(), query] as const,
  resourceType: () => [...auditLogsKeys.all, "resourceType"] as const,
  resourceTypes: <TQuery>(query: TQuery) => [
    ...auditLogsKeys.resourceType(),
    query,
  ],
}

export const auditLogQueryOptions = (
  fetchOpts?: FetchOptions<"get", "/audit-logs/">
) => {
  return queryOptions({
    queryKey: auditLogsKeys.lists(fetchOpts?.params?.query),
    queryFn: () =>
      api
        .GET("/audit-logs/", fetchOpts)
        .then(({ data }) => data)
        .catch(e => {
          throw e
        }),
  })
}

export const useAuditLogQuery = (
  fetchOpts?: FetchOptions<"get", "/audit-logs/">
) => {
  return useQuery(auditLogQueryOptions(fetchOpts))
}

export const auditLogResourceTypeOptions = (
  fetchOpts?: FetchOptions<"get", "/audit-logs/resource-types/">
) => {
  return queryOptions({
    queryKey: auditLogsKeys.resourceTypes(fetchOpts?.params?.query),
    queryFn: () =>
      api
        .GET("/audit-logs/resource-types/", fetchOpts)
        .then(({ data }) => data),
  })
}

export const useAuditLogResourceTypeQuery = (
  fetchOpts?: FetchOptions<"get", "/audit-logs/resource-types/">
) => {
  return useQuery(auditLogResourceTypeOptions(fetchOpts))
}

export interface AuditLogReportFilters {
  start_date?: string
  end_date?: string
  resource_type?: number
  action?: number
  facility?: number
}

export const useCreateAuditLogReportMutation = (
  mutationOptions?: UseMutationOptions<
    { message?: string } | undefined,
    unknown,
    AuditLogReportFilters
  >
) => {
  return useMutation({
    mutationFn: (body: AuditLogReportFilters) =>
      api
        // @ts-expect-error API — report endpoint's request/response shape isn't reflected in generated types yet
        .POST("/audit-logs/report/", { body })
        .then(({ data }) => data as { message?: string } | undefined),
    ...mutationOptions,
  })
}
